import { Conversion } from '@/entities/conversion/model/types'
import { Currencies } from '@/entities/curency'

type Currency = 'USDT' | 'RUB'

export type FarmStatus = 'active' | 'stopped' | 'canceled'

interface Balance {
  amount: number
  currency: Currency
}

interface Turnover {
  amount: number
  goal: number
  currency: Currency
}

interface Deals {
  current: number
  goal: number
}

interface Contractors {
  current: number
  goal: number
}

interface FinancialData {
  profit: Balance
  conversion: Conversion
  deals: Deals
  contractors: Contractors
  requisite_lifetime: string | null
  average_request_amount: number
  deal_confirmation_time: string
}

export interface FarmModelEx {
  status: 'active' | 'stopped' | 'canceled' | 'new'
  name: string
  balance: Balance
  turnover: {
    today: Turnover
    month: Turnover
  }
  today: FinancialData
  month: FinancialData
}

export enum WeekDays {
  Mon = 1,
  Tue = 2,
  Wed = 4,
  Thu = 8,
  Fri = 16,
  Sat = 32,
  Sun = 64,
}

export type FarmModel = {
  id: string
  createdAt: string
  lastModifiedAt: string | null
  isDeleted: boolean | null
  deletedAt: string | null
  isBlocked: boolean | null
  blockedAt: string | null
  blockedReason: string | null
  isDisabledByUser: boolean | null
  disabledAt: string | null
  name: string | null
  userId: string
  currency: Currencies.RUB | Currencies.USDT
  maxDailyLimit: number | null
  maxMonthlyLimit: number | null
  maxDailyTopupsCounter: number | null
  maxMonthlyTopupsCounter: number | null
  minTimeoutBetweenDealsInMinutes: number | null
  minDealAmount: number | null
  maxDealAmount: number | null
  dayOfWeek: WeekDays | null
  workHoursStartsAt: string | null
  workHoursEndsAt: string | null
}

export type NewFarmModel = {
  name: string | null
  maxDailyLimit: number | null
  maxMonthlyLimit: number | null
  maxDailyTopupsCounter: number | null
  maxMonthlyTopupsCounter: number | null
  minTimeoutBetweenDealsInMinutes: number | null
  minDealAmount: number | null
  maxDealAmount: number | null
  dayOfWeek: WeekDays | null
  workHoursStartsAt: string | null
  workHoursEndsAt: string | null
  currency: Currencies.RUB | Currencies.USDT
}

export type UpdateFarmModel = {
  id: string
  name: string
  maxDailyLimit: number
  maxMonthlyLimit: number
  maxDailyTopupsCounter: number
  maxMonthlyTopupsCounter: number
  minTimeoutBetweenDealsInMinutes: number
  minDealAmount: number
  maxDealAmount: number
  dayOfWeek: number
  workHoursStartsAt: string
  workHoursEndsAt: string
}


export const defaultFarmData = {
  id: '',
  createdAt: '',
  lastModifiedAt: null,
  isDeleted: null,
  deletedAt: null,
  isBlocked: null,
  blockedAt: null,
  blockedReason: null,
  isDisabledByUser: null,
  disabledAt: null,
  name: null,
  userId: '',
  currency: Currencies.RUB,
  maxDailyLimit: null,
  maxMonthlyLimit: null,
  maxDailyTopupsCounter: null,
  maxMonthlyTopupsCounter: null,
  minTimeoutBetweenDealsInMinutes: null,
  minDealAmount: null,
  maxDealAmount: null,
  dayOfWeek: WeekDays.Mon,
  workHoursStartsAt: null,
  workHoursEndsAt: null,
}
